import { render, staticRenderFns } from "./LocaleChangerLogin.vue?vue&type=template&id=b29bb282"
import script from "./LocaleChangerLogin.vue?vue&type=script&lang=js"
export * from "./LocaleChangerLogin.vue?vue&type=script&lang=js"
import style0 from "./LocaleChangerLogin.vue?vue&type=style&index=0&id=b29bb282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports